<template>
  <base-content>
    <div class="tw-flex tw-flex-col tw-mb-4">
      <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Operations Summary</h1>
      <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-3">
        <active-plans :business-id="businessId" />
        <active-prescriptions v-if="organization.usePrescriptionProgramSetting" :business-id="businessId" />
        <activities v-if="organization.useTodoSetting" :business-id="businessId" />
        <charges :business-id="businessId" />
        <active-disputes v-if="isAdministrator && !isLocationFiltered" :business-id="businessId" />
      </div>
      <div class="tw-mt-6 tw-mb-4">
        <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Practice Summary</h1>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
          <plan-counts-by-group :business-id="businessId" />
          <prescription-counts-by-group v-if="organization.usePrescriptionProgramSetting" :business-id="businessId" />
          <activities-by-type v-if="organization.useTodoSetting" :business-id="businessId" />
        </div>
      </div>
      <div v-if="isAdministrator && !isLocationFiltered" class="tw-mt-6 tw-mb-4">
        <h1 class="tw-text-xl md:tw-text-2xl tw-font-thin tw-mb-4">Revenue Summary</h1>
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3">
          <revenue-trend :business-id="businessId" />
          <monthly-revenue :business-id="businessId" />
        </div>
      </div>
    </div>
    <provider-notifications-modal v-if="isLocationFiltered" ref="notificationModal" :business-id="businessId" :initial-items="unreadNotifications" />
  </base-content>
</template>
<script>
import { mapGetters } from "vuex";
import ActivePlans from "@/views/business/dashboard/components/ActivePlans";
import ActivePrescriptions from "@/views/business/dashboard/components/ActivePrescriptions";
import Activities from "@/views/business/dashboard/components/Activities";
import ActivitiesByType from "@/views/business/dashboard/components/ActivitiesByType";
import Charges from "@/views/business/dashboard/components/Charges";
import ActiveDisputes from "@/views/business/dashboard/components/ActiveDisputes";
import PlanCountsByGroup from "@/views/business/dashboard/components/PlanCountsByGroup";
import PrescriptionCountsByGroup from "@/views/business/dashboard/components/PrescriptionCountsByGroup";
import RevenueTrend from "@/views/business/dashboard/components/RevenueTrend";
import MonthlyRevenue from "@/views/business/dashboard/components/MonthlyRevenue";
import ProviderNotificationsModal from "@/views/business/support/components/ProviderNotificationsModal.vue";

import { capitalize } from "lodash";

const TAKE_KEY = "predictile_business_uread_notifications_take";

export default {
  name: "BusinessDashboardView",
  components: {
    ActivePlans,
    ActivePrescriptions,
    Activities,
    ActivitiesByType,
    Charges,
    ActiveDisputes,
    PlanCountsByGroup,
    PrescriptionCountsByGroup,
    RevenueTrend,
    MonthlyRevenue,
    ProviderNotificationsModal,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      unreadNotifications: [],
      isLoading: false,
      page: {
        take: localStorage.getItem(TAKE_KEY) ? +localStorage.getItem(TAKE_KEY) : 50,
        skip: 0,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters("role", ["isBusinessAdministrator", "isPredictile", "isLocationFiltered"]),
    ...mapGetters("organization", ["organization"]),
    isAdministrator() {
      return this.isBusinessAdministrator(this.businessId) || this.isPredictile();
    },
  },
  mounted() {
    if (!sessionStorage.getItem("notificationChecked")) {
      this.checkUnreadNotifications();
      sessionStorage.setItem("notificationChecked", "true");
    }
  },
  methods: {
    capitalize,
    async checkUnreadNotifications() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/provider-notifications/unread?skip=${this.page.skip}&take=${this.page.take}`;
      url += `&locationFilter=${this.isLocationFiltered ? "true" : "false"}`;

      try {
        const res = await this.$axios.get(url);
        const items = res.data.items || [];

        if (items.length > 0) {
          this.unreadNotifications = items;

          this.$nextTick(() => {
            if (this.$refs.notificationModal && this.$refs.notificationModal.show) {
              this.$refs.notificationModal.show();
            }
          });
        }
      } catch (err) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to load notifications",
          message: "We had a problem retrieving the list of notifications. Please reload the page to try again.",
          error: err,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
